var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { styled, useTheme } from '@web/theme';
import React, { memo, useCallback, useMemo } from 'react';
import { SketchPicker } from 'react-color';
import { useBlocks } from '../ModuleBlock';
export var ColorPicker = memo(function (_a) {
    var id = _a.id, color = _a.color, onPreview = _a.onPreview, onChange = _a.onChange;
    var theme = useTheme();
    var list = useBlocks().blocks.list;
    var _onPreview = useCallback(function (color) { return onPreview({ field: id, color: color }); }, [id]);
    var _onChange = useCallback(function (color) { return onChange({ field: id, color: color }); }, [id]);
    var presetColors = useMemo(function () {
        var themeColors = [
            theme.page.bg,
            theme.page.txt,
            theme.block.bg,
            theme.block.txt,
            theme.accent.bg,
            theme.accent.txt,
            theme.accent2nd.bg,
            theme.accent2nd.txt,
            theme.accent3rd.bg,
            theme.accent3rd.txt,
            theme.brand.bg,
            theme.brand.txt,
            theme.button.bg,
            theme.button.txt,
            theme.cta.bg,
            theme.cta.txt,
        ];
        var arr = [];
        themeColors.map(function (themeColor) {
            if (!arr.includes(themeColor))
                arr.push(themeColor);
        });
        Object.values(list).map(function (block) {
            if (block.bg && !arr.includes(block.bg))
                arr.push(block.bg);
        });
        return arr;
    }, [list]);
    return (React.createElement(Picker, { id: "picker" },
        React.createElement(SketchPicker, { color: color, onChange: _onPreview, onChangeComplete: _onChange, presetColors: presetColors, disableAlpha: true })));
});
var Picker = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n"], ["\n"])));
var templateObject_1;
